import { render } from "./PanelSeed.vue?vue&type=template&id=5417caee"
import script from "./PanelSeed.vue?vue&type=script&lang=js"
export * from "./PanelSeed.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/avalia-assess/avalia-playbook-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__